import Vue from 'vue';

export default {
    find(parametros) {
        return Vue.axios.get("catalogo/IMSS/findTipoConsecuencias", { params: parametros }).then((response) => Promise.resolve(response.data)).catch((error) => Promise.reject(error));
    },
}